import * as React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Header } from './Header'
import { Footer } from './Footer'
import { Helmet } from 'react-helmet'
import { CookieModal } from './CookieModal';

// import {useTranslation} from "gatsby-plugin-react-i18next";
import '../styles/site.scss';

export const Layout = ({ children, activeDocMeta, themes, hideCookieNotification }) => {
	// const {t} = useTranslation();
	const queryData = useStaticQuery(graphql`
    query SiteQuery {
      site {
        siteMetadata {
          title
          description
        }
      }    
    }
  `);
	return (
		<>
			<Helmet>
				<meta charSet="utf-8" />
				<title>{(activeDocMeta.title ? activeDocMeta.title + ' - ' : '') + queryData.site.siteMetadata.title}</title>
				<meta
					name="description"
					content={activeDocMeta.desc ? activeDocMeta.desc : ''}
				/>
				<meta name="viewport" content="width=device-width, initial-scale=1" />
				<link rel="shortcut icon" href="/favicons/icon-32x32.png" type="image/png" />
			</Helmet>
			<div className="dialog-off-canvas-main-canvas" data-off-canvas-main-canvas="">
				<Header activeDocMeta={activeDocMeta} />
				<section className="page-container" id="main-content">
					<section id="content" className="section--content">
						<main role="main">
							{children}
						</main>
					</section>
				</section>
				<Footer activeDocMeta={activeDocMeta} themes={themes} />
			</div>
			{(hideCookieNotification === undefined || hideCookieNotification === false) &&
				<CookieModal/>
			}
		</>
	);
}
